module.exports = __webpack_public_path__ + "static/img/anxun43.e27d5e1d.png";